import { Box, SxProps, Theme, Typography, useTheme } from "@mui/material";

// ----------------------------------------------------------------------

/** Hexágono flat-top do logo — NUNCA usar pointy-top (ver handoff) */
export const HEXAGON_POINTS = "2,55 26,13.4 74,13.4 98,55 74,96.6 26,96.6";

interface HexagonProps {
  /** Largura em px; a altura é proporcional (×1.1, viewBox 100×110) */
  size?: number;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  sx?: SxProps<Theme>;
}

export function Hexagon({ size = 44, fill = "none", stroke, strokeWidth = 3, sx }: HexagonProps) {
  return (
    <Box
      component="svg"
      viewBox="0 0 100 110"
      aria-hidden
      sx={[{ width: size, height: size * 1.1, display: "block" }, ...(Array.isArray(sx) ? sx : [sx])] as SxProps<Theme>}
    >
      <polygon points={HEXAGON_POINTS} fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
    </Box>
  );
}

interface HexTileProps {
  /** Texto de onde sai a inicial exibida no centro (ex.: nome do ativo) */
  label: string;
  size?: number;
  /** Sobrescreve as iniciais exibidas (padrão: 1ª letra do label) */
  initials?: string;
}

/** Tile de ativo: hexágono creme (claro) / dourado translúcido (escuro) com a inicial */
export function HexTile({ label, size = 44, initials }: HexTileProps) {
  const theme = useTheme();
  const text = initials ?? label.trim().charAt(0).toUpperCase();
  return (
    <Box
      sx={{
        position: "relative",
        width: size,
        height: size * 1.1,
        display: "grid",
        placeItems: "center",
      }}
    >
      <Hexagon
        size={size}
        fill={theme.palette.brand.hexTileBg}
        stroke={theme.palette.brand.hexTileStroke}
        sx={{ position: "absolute", inset: 0 }}
      />
      <Typography
        component="span"
        sx={{
          position: "relative",
          fontFamily: theme.typography.fontFamilyDisplay,
          color: "primary.main",
          fontSize: size * (text.length > 1 ? 0.3 : 0.38),
          lineHeight: 1,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
